
import { useState } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function WishesSection() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: '全部', icon: 'ri-heart-line' },
    { id: 'love', name: '爱情', icon: 'ri-heart-fill' },
    { id: 'career', name: '事业', icon: 'ri-briefcase-line' },
    { id: 'health', name: '健康', icon: 'ri-heart-pulse-line' },
    { id: 'family', name: '家庭', icon: 'ri-home-heart-line' },
    { id: 'study', name: '学业', icon: 'ri-book-line' },
    { id: 'travel', name: '旅行', icon: 'ri-map-pin-line' }
  ];

  const wishes = [
    {
      id: 1,
      content: '希望今年能找到心仪的工作，实现自己的职业梦想！',
      category: 'career',
      author: '追梦人',
      avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20person%20avatar%2C%20friendly%20smile%2C%20business%20casual%20style%2C%20modern%20portrait%2C%20clean%20background%2C%20professional%20headshot&width=60&height=60&seq=avatar-1&orientation=squarish',
      likes: 128,
      time: '2小时前',
      status: 'pending'
    },
    {
      id: 2,
      content: '愿家人身体健康，平平安安，每天都开开心心！',
      category: 'health',
      author: '温暖的心',
      avatar: 'https://readdy.ai/api/search-image?query=middle-aged%20person%20with%20warm%20smile%2C%20caring%20expression%2C%20casual%20clothing%2C%20friendly%20face%2C%20natural%20lighting%2C%20portrait%20style&width=60&height=60&seq=avatar-2&orientation=squarish',
      likes: 256,
      time: '5小时前',
      status: 'fulfilled'
    },
    {
      id: 3,
      content: '希望能遇到那个对的人，一起走过人生的每一个春夏秋冬。',
      category: 'love',
      author: '等待爱情',
      avatar: 'https://readdy.ai/api/search-image?query=young%20romantic%20person%20avatar%2C%20hopeful%20expression%2C%20soft%20lighting%2C%20dreamy%20style%2C%20gentle%20smile%2C%20artistic%20portrait&width=60&height=60&seq=avatar-3&orientation=squarish',
      likes: 89,
      time: '1天前',
      status: 'pending'
    },
    {
      id: 4,
      content: '考研顺利通过，能够进入理想的大学继续深造！',
      category: 'study',
      author: '努力学子',
      avatar: 'https://readdy.ai/api/search-image?query=student%20avatar%20with%20determined%20expression%2C%20books%20in%20background%2C%20academic%20style%2C%20youthful%20appearance%2C%20confident%20smile&width=60&height=60&seq=avatar-4&orientation=squarish',
      likes: 167,
      time: '2天前',
      status: 'pending'
    },
    {
      id: 5,
      content: '今年能够和家人一起去日本旅行，看樱花盛开的美景！',
      category: 'travel',
      author: '旅行达人',
      avatar: 'https://readdy.ai/api/search-image?query=travel%20enthusiast%20avatar%2C%20adventurous%20spirit%2C%20outdoor%20clothing%2C%20excited%20expression%2C%20wanderlust%20vibe%2C%20natural%20background&width=60&height=60&seq=avatar-5&orientation=squarish',
      likes: 203,
      time: '3天前',
      status: 'fulfilled'
    },
    {
      id: 6,
      content: '希望父母的身体越来越好，能够陪伴他们更多的时光。',
      category: 'family',
      author: '孝顺儿女',
      avatar: 'https://readdy.ai/api/search-image?query=caring%20person%20avatar%2C%20loving%20expression%2C%20family-oriented%2C%20warm%20personality%2C%20gentle%20features%2C%20heartwarming%20smile&width=60&height=60&seq=avatar-6&orientation=squarish',
      likes: 312,
      time: '4天前',
      status: 'pending'
    }
  ];

  const filteredWishes = selectedCategory === 'all' 
    ? wishes 
    : wishes.filter(wish => wish.category === selectedCategory);

  const getStatusBadge = (status: string) => {
    return status === 'fulfilled' ? (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
        <i className="ri-check-line mr-1"></i>
        已实现
      </span>
    ) : (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
        <i className="ri-time-line mr-1"></i>
        许愿中
      </span>
    );
  };

  return (
    <section id="wishes" className="py-20 bg-gradient-to-b from-pink-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            <strong>许愿墙</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            这里汇聚了千万用户的美好愿望，见证着每一个梦想的实现。分享你的愿望，让更多人为你加油！
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 py-2 rounded-full font-medium transition-all duration-200 flex items-center space-x-2 cursor-pointer ${
                selectedCategory === category.id
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:text-purple-600 hover:shadow-md border border-gray-200'
              }`}
            >
              <i className={`${category.icon} text-sm`}></i>
              <span>{category.name}</span>
            </button>
          ))}
        </div>

        {/* Wishes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredWishes.map((wish) => (
            <Card key={wish.id} hover className="relative">
              <div className="flex items-start space-x-3 mb-4">
                <img 
                  src={wish.avatar} 
                  alt={wish.author}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h4 className="font-semibold text-gray-800">{wish.author}</h4>
                    {getStatusBadge(wish.status)}
                  </div>
                  <p className="text-sm text-gray-500">{wish.time}</p>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4 line-clamp-3">
                {wish.content}
              </p>

              <div className="flex items-center justify-between">
                <button className="flex items-center space-x-2 text-gray-500 hover:text-red-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-heart-line"></i>
                  <span className="text-sm">{wish.likes}</span>
                </button>
                <button className="text-gray-500 hover:text-purple-600 transition-colors duration-200 cursor-pointer">
                  <i className="ri-share-line"></i>
                </button>
              </div>

              {wish.status === 'fulfilled' && (
                <div className="absolute top-4 right-4">
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                </div>
              )}
            </Card>
          ))}
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-purple-600 mb-2">50万+</div>
            <div className="text-gray-600">总许愿数</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-pink-600 mb-2">25万+</div>
            <div className="text-gray-600">已实现</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-orange-600 mb-2">10万+</div>
            <div className="text-gray-600">许愿用户</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">50%</div>
            <div className="text-gray-600">实现率</div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button size="lg" className="mr-4">
            <i className="ri-add-line mr-2"></i>
            我要许愿
          </Button>
          <Button variant="outline" size="lg">
            <i className="ri-eye-line mr-2"></i>
            查看更多
          </Button>
        </div>
      </div>
    </section>
  );
}
